import PdImage from '../../../components/pd-image/pd-image'
import PdMedia from '../../../components/pd-media/pd-media'
import WatchVideo from '../../../components/pd-watch-video/pd-watch-video'
import { useD9 } from '../../../hooks/use-d9-data'

export function Section2() {
  const { section2 } = useD9()

  return (
    <div className="relative w-full h-[177.9vw] laptop:h-[56.2vw] flex justify-center items-center bg-black">
      <div className="absolute top-0 left-0 right-0 bottom-0">
        <PdMedia type="video" src={section2.backgroundVideo} />
      </div>
      <WatchVideo className="relative" videoUrl={section2.video} type="primary" />
      <div className="w-full h-2px bg-black absolute bottom-[-1px]"></div>
    </div>
  )
}
